import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * CompanyBadge — квадратный бейдж инициалов организации (`.co-badge` макета).
 * Имеет доступное имя (название организации), чтобы инициалы не были единственным источником.
 *
 * Фон — `surface-group` (bg-group) по ЯВНОМУ предписанию спеки ui-components («на поверхности-группе
 * surface-group»). Это осознанное расхождение с макетом (`.co-badge { background: var(--bg-gray) }`):
 * реализация ведётся по спекам OpenSpec (канон), которые здесь уточняют макет. Оба значения — токены.
 */
export interface CompanyBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  initials: string
  /** Полное название организации — доступное имя бейджа. */
  company: string
}

export const CompanyBadge = forwardRef<HTMLSpanElement, CompanyBadgeProps>(
  ({ className, initials, company, ...props }, ref) => (
    <span
      ref={ref}
      role="img"
      aria-label={company}
      className={cn(
        'inline-flex size-company items-center justify-center rounded-7 bg-group text-12 font-semibold text-txt',
        className,
      )}
      {...props}
    >
      <span aria-hidden>{initials}</span>
    </span>
  ),
)
CompanyBadge.displayName = 'CompanyBadge'
